import React, { useEffect, useMemo, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { MetaData } from "../../../definitions/website";
import { useAnonymousApi } from "../../../hooks/useApi";
import withMemo from "../../hoc/withMemo";

interface HeadProps {
  title?: string;
  description?: string;
  image?: string;
  canonical?: string;
  type?: string;
}
const TITLE = "Zostel | Largest Branded Hostel Chain in India & Nepal";
const DESCRIPTION =
  "Zostel is the World’s largest backpacker hostel chain. Stay with us at our backpacker hostels, homestays, and premium stays to explore the best of India and Nepal.";

const Head: React.FC<HeadProps> = ({
  title = TITLE,
  description,
  image,
  canonical,
  type = "website",
}) => {
  const location = useLocation();
  const metadataApi = useAnonymousApi("STAY_METADATA");

  const [pageTitle, setPageTitle] = useState<string>(title || TITLE);
  const [pageDescription, setPageDescription] = useState<string>(
    description || DESCRIPTION
  );

  useEffect(() => {
    setPageTitle(title);
  }, [title]);

  const url = useMemo(
    () => `${window.location.origin}${location.pathname}`,
    [location.pathname]
  );

  useEffect(() => {
    if (metadataApi) {
      metadataApi
        .get(`?url=https://www.zostel.com${location.pathname}`)
        .then((res) => {
          const pageData: MetaData = res.data;
          if (pageData.type === "meta") {
            pageData.data.title &&
              pageData.data.title !== null &&
              pageData.data.title !== "" &&
              setPageTitle(res.data.data.title);
            pageData.data.meta.find(
              (metafield) =>
                metafield.name === "description" &&
                metafield.content !== null &&
                metafield.content !== "" &&
                setPageDescription(metafield.content)
            );
          }
        });
    }
  }, [location, metadataApi]);

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="title" content={pageTitle} />
      <meta name="description" content={pageDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:image" content={image || ""} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={pageTitle} />
      <meta property="twitter:description" content={pageDescription} />
      <meta property="twitter:image" content={image || ""} />
      {canonical && <link rel="canonical" href={canonical} />}
    </Helmet>
  );
};

export default withMemo(Head);
